import React from 'react';
import { Frame } from '../Frame';
import Lozenge from '@atlaskit/lozenge';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { LozengeWrapper } from '../IconAndTitleLayout/styled';
import { HoverCard } from '../../HoverCard/index';
export class InlineCardResolvedView extends React.Component {
  renderLozenge() {
    const {
      lozenge
    } = this.props;
    if (!lozenge) {
      return null;
    }
    const appearance = lozenge.appearance || 'default';
    return /*#__PURE__*/React.createElement(LozengeWrapper, null, /*#__PURE__*/React.createElement(Lozenge, {
      testId: "inline-card-resolved-view-lozenge",
      appearance: appearance
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: lozenge.style,
      isBold: lozenge.isBold
    }, lozenge.text));
  }
  render() {
    const {
      id,
      title = '',
      isSelected,
      isHovered,
      onClick,
      icon,
      link,
      testId = 'inline-card-resolved-view',
      titleTextColor,
      titlePrefix,
      showHoverPreview = false,
      actionOptions
    } = this.props;
    const inlineCardResolvedView = /*#__PURE__*/React.createElement(Frame, {
      testId: testId,
      link: link,
      isSelected: isSelected,
      isHovered: isHovered,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
      emoji: titlePrefix,
      icon: icon,
      title: title,
      titleTextColor: titleTextColor
    }), this.renderLozenge());
    if (showHoverPreview && link) {
      return /*#__PURE__*/React.createElement(HoverCard, {
        id: id,
        url: link,
        actionOptions: actionOptions
      }, inlineCardResolvedView);
    }
    return inlineCardResolvedView;
  }
}